import { Text } from "@chakra-ui/react";

const InlineError = ({ errorMessage = "Error" }) => {
  return (
    <Text as="em" color="red.500">
      {errorMessage}
    </Text>
  );
};

export default InlineError;
